import unlockedSunrise from "assets/illustrations/unlockedSunrise.svg"
import { useHasValueChanged, useOnEscape } from "hooks"
import { useDisableDocumentScroll } from "hooks/src/useDisableDocumentScroll"
import { Button, Modal } from "materia"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { backgroundImageStyle } from "ui-tools"
import { FiestaImage } from "utility-components"
import { useConfettiContext } from "../../../components/ConfettiBanner/ConfettiContextProvider"
import { Sparkles } from "../../../components/Sparkles"
import type { Data } from "../Journey/gql"
import s from "./JourneyUnlockedModal.module.scss"

export const JourneyUnlockedModal = ({
  data,
  initialShowModal,
}: {
  data: Data
  initialShowModal?: boolean
}) => {
  const { isConfettiBlocked } = useConfettiContext()
  const [isOpen, setIsOpen] = useState(true)

  const { unlocked } = data

  const hasUnlockedJourneys = unlocked.nodes.length > 0
  const hasUnlockedJourneysChanged = useHasValueChanged(hasUnlockedJourneys)

  const showModal =
    initialShowModal ??
    (isOpen &&
      !isConfettiBlocked &&
      hasUnlockedJourneys &&
      hasUnlockedJourneysChanged)

  if (!showModal) return

  return <Content data={data} setIsOpen={setIsOpen} />
}

const Content = ({
  data,
  setIsOpen,
}: {
  data: Data
  setIsOpen: (value: boolean) => void
}) => {
  const { t } = useTranslation()

  const onClose = () => setIsOpen(false)

  useOnEscape(onClose)
  useDisableDocumentScroll()

  const { unlocked } = data

  const journeyImage = unlocked.nodes[0]?.backgroundImageUrl ?? ""
  const journeyTitle = unlocked.nodes[0]?.title ?? ""

  return (
    <Modal
      onClose={onClose}
      overflowAuto={false}
      ariaLabel="Unlocked new journey"
    >
      <div className={s.journeyUnlockedModal}>
        <Sparkles />

        <div
          className={s.journeyUnlockedModal__cover}
          style={backgroundImageStyle(unlockedSunrise)}
        >
          <FiestaImage
            sizes="90px"
            className={s.journeyUnlockedModal__coverJourneyThumbnail}
            src={journeyImage}
            alt=""
          />
        </div>
        <div className={s.journeyUnlockedModal__content}>
          <h3 className={s.journeyUnlockedModal__contentModalTitle}>
            {t("journey.NEW_JOURNEY_UNLOCKED")}
          </h3>
          <p className={s.journeyUnlockedModal__contentJourneyTitle}>
            {journeyTitle}
          </p>
          <Button onClick={onClose} borderRadius={"32"}>
            {t("journey.NEW_JOURNEY_UNLOCKED_CONTINUE")}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
